import Image from 'next/image';
import React from 'react';

import { IResolvedCardItem } from '@/src/utils/collections/cards.mapper';
import { CardAction } from '@/src/components/cards/CardAction/CardAction';
import { ILocaleType } from '@/src/types';
import { IZoneWithDestinationsAndPromo } from '@/src/modules/destinations/destinations.modules';
import { CardContent } from '@/src/components/cards/CardContent/CardContent';

interface IProps {
  items: IResolvedCardItem[];
  positionDesktop?: 'standard' | 'inverted';
  positionMobile?: 'standard' | 'inverted';
  destinations?: Record<string, IZoneWithDestinationsAndPromo>;
  locale: ILocaleType;
  backgroundColor?: string;
}

export const CardTwoColumns = ({
  items,
  positionMobile,
  positionDesktop,
  locale,
  backgroundColor,
  destinations,
}: IProps) => {
  const mediaCard = items[0];
  const contentCard = items[1];
  const mediaWidths = {
    '1/3': 'md:w-1/3',
    '2/5': 'md:w-2/5',
    '1/2': 'md:w-1/2',
    '3/5': 'md:w-3/5',
    '2/3': 'md:w-2/3',
  };
  const contentWidths = {
    '1/3': 'md:w-2/3',
    '2/5': 'md:w-3/5',
    '1/2': 'md:w-1/2',
    '3/5': 'md:w-2/5',
    '2/3': 'md:w-1/3',
  };

  return (
    <div
      className={`mx-4 md:mx-auto ${positionDesktop === 'standard' ? 'md:flex-row' : 'md:flex-row-reverse'} ${positionMobile === 'standard' ? 'flex-col' : 'flex-col-reverse'} flex max-w-1200 items-stretch gap-8`}
    >
      <div
        className={`${mediaWidths[mediaCard.mediaWidth]} relative flex min-h-[220px] flex-col justify-between overflow-hidden rounded-3xl`}
      >
        {mediaCard.media.type === 'image' && mediaCard.media.data && (
          <Image
            placeholder={'blur'}
            blurDataURL={'/static/images/placeholder.webp'}
            objectFit={'cover'}
            objectPosition={'top'}
            fill
            src={mediaCard.media.data.image}
            alt={mediaCard.media.data.alt || ''}
          />
        )}
        {mediaCard.media.type === 'icon' && mediaCard.media.data && (
          <Image
            width={64}
            height={64}
            src={mediaCard.media.data.icon}
            alt={mediaCard.media.data.alt || ''}
          />
        )}
      </div>

      {contentCard && (
        <div
          className={`flex flex-col justify-between rounded-3xl ${contentCard.content.type === 'blocks' ? 'p-1' : 'p-10'} ${backgroundColor} ${contentWidths[mediaCard.mediaWidth]}`}
        >
          <div className={'space-y-6'}>
            <div className={'text-3xl font-bold xl:text-4xl'}>
              {contentCard.title}
            </div>
            <CardContent cardContent={contentCard.content} />
          </div>
          <div className={'flex gap-4 lg:mt-0'}>
            {contentCard.media.type === 'image' && contentCard.media.data && (
              <Image
                placeholder={'blur'}
                blurDataURL={'/static/images/placeholder.webp'}
                src={contentCard.media.data.image}
                alt={contentCard.media.data.alt || ''}
              />
            )}
            {contentCard.media.type === 'icon' && contentCard.media.data && (
              <Image
                width={64}
                height={64}
                src={contentCard.media.data.icon}
                alt={contentCard.media.data.alt || ''}
              />
            )}
            {contentCard.action.type !== 'none' && (
              <CardAction
                destinations={destinations}
                action={contentCard.action}
                locale={locale}
              />
            )}
          </div>
        </div>
      )}
    </div>
  );
};
